export const DETAIL_ERROR_SET = 'DETAIL_ERROR_SET'
export const DETAIL_LOADING_SET = 'DETAIL_LOADING_SET'
export const DETAIL_SET = 'DETAIL_SET'